<button
  *ngIf="!isHidden"
  mat-icon-button
  class="action-button"
  [title]="model.labelTooltip"
  (click)="onClick()"
  [disabled]="model.disabled"
  data-test="gsm-action-button_button"
>
  <mat-icon>{{ model.icon }}</mat-icon>
</button>
